<script>
	import PostInfo from "./PostInfo.svelte";
	import PostContent from "./PostContent.svelte";
	import PostText from "../../../postBox/PostText.svelte";

	export let post;
	export let highlight = false;
</script>

<div
	class="grow bg-base-100 flex flex-col sm:flex-row gap-4 py-4 px-6 rounded-xl"
	class:bg-primary-content={highlight}
	class:text-primary={highlight}
>
	<div class="w-24 lg:w-32 flex-none flex flex-col">
		<PostInfo {post} {highlight} />
	</div>
	<div class="grow">
		<PostContent {post} {highlight}>
			<PostText text={post.text} />
		</PostContent>
	</div>
</div>
